import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Tab, useMediaQuery, useTheme, Grid, Paper, Typography, CardContent, ListItem, Chip, Box } from '@mui/material';
import MyTable from '../../../components/MyTable';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store';
import { searchCompanyEmployeesVacationsResume, searchCompanyEmployeeVacationsDetails, setCompanyEmployeesLoading } from '../../../store/slices/userRequests';
import MySelectCompany from '../../../components/MySelectCompany';
import { getDatestring } from '../../../utils/date';
import { getEmployeesInMyCharge } from '../../../api/s10OrganizationApi';
import MySnackbar from '../../../components/MySnackbar';

interface ChipData {
  key: string;
  label: string;
  company: string;
}

const VacationResume = ({viewType}: {viewType: "All" | "InMyCharge" | "ToApprove"}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch<AppDispatch>();
  const {connectionId} = useSelector((state: RootState) => state.auth);
  const {employees, loading, totalItems} = useSelector((state: RootState) => state.userRequests).companyEmployees;
  const {details, totalItems:  totalItemsVacationsDetails} = useSelector((state: RootState) => state.userRequests).employeesVacationResume;
  const [rucSelected, setRucSelected] = useState<string>("")
  const userAdded = useRef<ChipData[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("")
  const [selectedUsers, setSelectedUsers] = useState<readonly ChipData[]>([]);
  const [selectedTab, setSelectedTab] = useState(useMediaQuery(theme.breakpoints.down('sm')) 
                                          ? 0 
                                          : 1);
                                          
  const [pageSizeVacationDetails, setPageSizeVacationDetails] = useState<number>(10);
  const [pageVacationDetails, setPageVacationDetails] = useState<number>(1);
  const [searchValueVacationDetails] = useState<string>("")
  const [employeesCodes, setEmployeesCodes] = useState<string | null>(null)
  const [errorMsg, setErrorMsg] = useState<string>("")
  const [loadingEmployees, setLoadingEmployees] = useState<boolean>(true)


  const titleOne ='Colaborador';
  const titleTwo = 'Vacaciones';
  const EmployeesHeader = [
    {
        label: "Nombre",
        rowKeyName: "Descripcion",
    },{
        label: "Documento",
        rowKeyName: "DNI",
    },{
        label: "Email",
        rowKeyName: "EMail",
    }
  ];

  useEffect(() => {
    if (!connectionId || !rucSelected) {
        return;
    }
    getInitialTablesData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectionId, rucSelected]);

  useEffect(() => {
    const copyUsers = [...selectedUsers]
     userAdded.current = copyUsers;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUsers])
  
  const getInitialTablesData = async () => {
    setLoadingEmployees(true);
    setErrorMsg("");
    let _employeesCodes =  "";
    dispatch(setCompanyEmployeesLoading(true));
    setEmployeesCodes(null);
    const finalRuc = rucSelected === "all" ? "" : rucSelected;
    if (viewType === "InMyCharge") {
        const result = await getEmployeesInMyCharge(finalRuc);
        if (!result?.data?.length) {
            setErrorMsg("No posees personal asignado en el organigrama")
            return;
        }
        _employeesCodes = result?.data.join(",")
    }
    console.log('_employeesCodes', _employeesCodes)
    dispatch(setCompanyEmployeesLoading(false));
    setLoadingEmployees(false);
    setEmployeesCodes(_employeesCodes);
  }

  useEffect(() => {
    if (loading || !connectionId || !rucSelected || employeesCodes === null || loadingEmployees) {
        return;
    }
    dispatch(searchCompanyEmployeesVacationsResume(
      employeesCodes,
      rucSelected === 'all' ? '' : rucSelected, 
      pageSize, 
      page, 
      searchValue,
    ))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectionId, rucSelected, pageSize, page, searchValue, employeesCodes]);

  useEffect(() => {
    if (loading || !connectionId || !rucSelected) {
      return;
    }
    dispatch(searchCompanyEmployeeVacationsDetails(
      selectedUsers.map(u => u.key).join('|'),
      rucSelected === 'all' ? '' : rucSelected,
      searchValueVacationDetails,
      pageSizeVacationDetails, 
      pageVacationDetails, 
    ))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUsers, rucSelected]);
  
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const handleAdd = (user: ChipData) => {
    const users = [...userAdded.current];
    if (!users.find(u => u.key === user.key)) {
        // const users = userAdded.current;
        setSelectedUsers([user]);
        setSelectedTab(1);
    } else {
        setSelectedUsers([]);
        setSelectedTab(0);
    }
  };

  const handleDelete = (userToDelete: ChipData) => () => {
      setSelectedUsers((selectedUsers) => selectedUsers.filter((user) => user.key !== userToDelete.key));
      setSelectedTab(0);
  };
  

  return (
    <Grid container spacing="1rem" marginTop='.5rem'>
      <MySelectCompany
          setRucSelected={(value) => {
            setRucSelected(value);
            setSelectedUsers([]);
            setSelectedTab(0);
          }} 
          rucSelected={rucSelected}
          includeAllCompaniesOption={true}
          allCompaniesOptionValue={'all'}
      />
      <Grid item xs={12} sx={{mt: {xs: ".5rem", md: 0}}}>
        <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            centered
            indicatorColor="primary"
            textColor="primary"
            sx={{display: {xs: "block", md: "none"}}}
        >
            <Tab style={{padding: '10px'}} label={titleOne}/>
            <Tab style={{padding: '10px'}} label={titleTwo} />
        </Tabs>
      </Grid>
      {(!isMobile ||  selectedTab === 0) &&
        <Grid pt=".5rem" width={!isMobile ? "33%" : "100%"}>
          <Paper
            elevation={3}
            style={{
              width: "100%", 
              borderRadius: "0.5rem",
              minHeight: "10rem",
              padding: "1.5rem"
            }}
          >
            <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginBottom: ".5rem"}}>
                {titleOne}
            </Typography>
            <MyTable
              tableHeadRows={EmployeesHeader}
              tableRows={employees}
              onChangeItemsPerPage={setPageSize}
              onChangePageNumber={setPage}
              onChangeSearchInputString={setSearchValue}
              searchInputString={searchValue}
              totalItems={totalItems}
              totalPages={totalItems / pageSize}
              loading={false}
              cardComponent={{
                changeViewOptionHidden: true,
                imageData: {
                    descriptionRowName: "Descripcion",
                },
                numberOfCards: 1,
                cardContent:  (row) => {
                    return (
                        <CardContent style={{padding: "0 1rem 1rem 50px", textAlign: "start"}}>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Empresa: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Empresa}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Saldo: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Saldo}
                                </Typography>
                            </Typography>
                        </CardContent>
                    )
                },
                onClick: (row) => {
                    return handleAdd({
                      key: row.CodIdentificador, 
                      label: row.Descripcion, 
                      company: row.Empresa})
                },
                className: (row) => {
                    return selectedUsers.find(e => e.key === row.CodIdentificador)
                        ? "selectable-card-selected"
                        : "selectable-card"
                }
              }}
              tableOptionsBar={{
                useDrawer: false,
              }}
            />
            
          </Paper>
        </Grid>
      }
      {(!isMobile ||  selectedTab === 1) && 
        <Grid pt=".5rem" pl=".5rem" width={!isMobile ? "67%" : "100%"}>
          <Paper
            elevation={3}
            style={{
              width: "100%",
              marginLeft: !isMobile ? "1rem" : "0",
              borderRadius: "0.5rem",
              minHeight: "10rem",
              padding: "1.5rem"
            }}
          >
            <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginBottom: ".5rem"}}>
                {titleTwo}
            </Typography>
            <Grid
              sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                  listStyle: 'none',
                  p: 0.5,
                  m: 0,
              }}
              component="ul"
            >
              {selectedUsers.map((data, i) => {
                let icon;
                return (
                  <ListItem key={i}>
                    <Chip
                      icon={icon}
                      label={
                        <Box component="span">
                          <Typography variant="body2" display="block">{data.label}</Typography>
                          <Typography variant="body2" display="block">{data.company}</Typography>
                        </Box>
                      }
                      onDelete={handleDelete(data)}
                    />
                  </ListItem>
                );
              })}
            </Grid>


            
            <MyTable
              tableHeadRows={EmployeesHeader}
              tableRows={details}
              onChangeItemsPerPage={setPageSizeVacationDetails}
              onChangePageNumber={setPageVacationDetails}
              // onChangeSearchInputString={setSearchValueVacationDetails}
              // searchInputString={searchValue}
              hiddenFilterOptions={true}
              totalItems={totalItemsVacationsDetails}
              totalPages={totalItemsVacationsDetails / pageSizeVacationDetails}
              loading={false}
              cardComponent={{
                changeViewOptionHidden: true,
                // numberOfCards: 1,
                cardContent:  (row) => {
                  return (
                    <CardContent style={{padding: "1rem", textAlign: "start"}}>
                      <Grid container direction="row" alignItems="center" justifyContent="space-between">
                        <Grid item xs>
                          <Typography variant="subtitle2" color="text.primary" marginBottom=".2rem">
                            {row.Descripcion}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Typography variant="body1" style={{marginTop: ".2rem"}}>
                        Empresa: {" "} {row.Empresa}
                      </Typography>
                      <Typography variant="body1" style={{marginTop: ".2rem"}}>
                        Año: {" "} {row.Anno}
                      </Typography>
                      <Typography variant="body1" style={{marginTop: ".2rem"}}>
                        Del: {" "}
                        <Typography variant="body2" component="span">
                            {row.Del ? getDatestring(row.Del, '-', false) : ''}
                        </Typography>
                        {" "} Al: {" "}
                        <Typography variant="body2" component="span">
                            {row.Al ? getDatestring(row.Al, '-', false): ''}
                        </Typography>
                      </Typography>
                      <table 
                        id="table-information"
                        style={{
                            width: "100%", 
                            borderSpacing: "0px 0rem",
                            borderRadius: "0.5rem",
                        }}
                      >
                          
                        <tbody>
                          {[
                            {name: "Total días acumulados", value: row.DiasGanados}, 
                            {name: "Total días solicitados", value: row.DiasProgramado}, 
                            {name: "Total días Utilizado", value: row.DiasUtilizado}, 
                            {name: "Saldo", value: row.Saldo}, 
                            {name: "Total Días", value: row.TotalDias}
                          ].map((row, i) => (
                              <tr key={i} >
                                <td>
                                  <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                    {row.name}
                                  </Typography>
                                </td>
                                <td style={{textAlign: 'end'}}>
                                  <Typography variant="body2" component="span">
                                    {Number(row.value).toFixed(2)}
                                  </Typography>
                                </td>
                          </tr>))}
                        </tbody>
                      </table>
                    </CardContent>
                  )
                },
              }}
              tableOptionsBar={{
                useDrawer: false,
              }}
            />

          </Paper>
        </Grid>
      }
      <MySnackbar
          open={errorMsg !== ""}
          autoHideDuration={6000}
          msg={errorMsg}
          severity="error"
          onClose={() => setErrorMsg("")} 
      />
    </Grid>
  );
};

export default VacationResume;